module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentTemplate != null) ? _c('div', [_c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_ContentContinueTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.currentTemplate), function(template) {
    return _c('div', {
      staticClass: "cards__item",
      on: {
        "click": function($event) {
          return _vm.selectLayout(template)
        }
      }
    }, [_c('img', {
      staticClass: "cards__image",
      attrs: {
        "src": _vm.getCurrentImg(template)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cards__text"
    }, [_c('p', [_vm._v(_vm._s(_vm.L.localize("Label_Current")))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_ContentTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.usableTemplates), function(template) {
    return _c('div', {
      staticClass: "cards__item",
      on: {
        "click": function($event) {
          return _vm.selectTemplate(template)
        }
      }
    }, [_c('img', {
      staticClass: "cards__image",
      attrs: {
        "src": _vm.getLayoutImg(template)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cards__text"
    }, [_c('p', [_vm._v(_vm._s(template.name))])])])
  }), 0), _vm._v(" "), _c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_ContentSecondTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.layouts), function(layout) {
    return _c('div', {
      staticClass: "cards__item",
      on: {
        "click": function($event) {
          return _vm.selectLayout(layout)
        }
      }
    }, [_c('img', {
      staticClass: "cards__image",
      attrs: {
        "src": layout.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cards__text"
    }, [_c('p', [_vm._v(_vm._s(layout.title))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-707eae8d!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/form/CampaignContent.vue
// module id = 745
// module chunks = 1